import React, { FC, useCallback, useState } from 'react';
import { TextField } from '@material-ui/core';
import { createUseStyles } from 'src/theming';
import Button from 'src/components/Button';
import { MdAdd as TimerIcon } from '@react-icons/all-files/md/MdAdd';
import AddInterventionDialog from './components/AddInterventionDialog';
import Intervention, { AddInterventionOptions } from '../../../../../../interfaces/api/Intervention';
import moment from 'moment';

interface Props {
  interventions: Intervention[];
  onCreateIntervention: (addInterventionOptions: AddInterventionOptions) => void;
}

const useStyles = createUseStyles({
  root: {
    display: 'flex',
  },
  button: {
    height: '100%',
    marginLeft: '10px !important',
  },
});

const Timer: FC<Props> = ({ interventions, onCreateIntervention }) => {
  const [isAddInterventionDialogOpen, setIsAddInterventionDialogOpen] = useState(false);
  const classes = useStyles();

  const displayTotalInterventionsDurations = useCallback(() => {
    const duration = Object.values(interventions).reduce((total, intervention) => {
      const duration = moment(intervention.endDate).diff(intervention.startDate, 'minutes');
      return total + duration;
    }, 0);

    const momentDuration = moment.duration(duration, 'minutes');

    const days = momentDuration.days();
    const hours = momentDuration.hours();
    const minutes = momentDuration.minutes();

    return `${days ? `${days}j ` : ''}${hours ? `${hours}h ` : ''}${minutes}min`;
  }, [interventions]);

  return (
    <>
      <div className={classes.root}>
        <TextField
          variant='outlined'
          label='Temps passé sur le ticket'
          value={displayTotalInterventionsDurations()}
          InputProps={{ readOnly: true }}
          fullWidth
        />

        <Button
          className={classes.button}
          variant='outlined'
          size='small'
          color='primary'
          onClick={() => setIsAddInterventionDialogOpen(true)}
        >
          <TimerIcon size={20} />
        </Button>
      </div>

      <AddInterventionDialog
        onClose={() => setIsAddInterventionDialogOpen(false)}
        open={isAddInterventionDialogOpen}
        onValidate={onCreateIntervention}
      />
    </>
  );
};

export default Timer;
